import { Preferences } from '@capacitor/preferences';
import { Toast } from 'antd-mobile';
import { current } from 'immer';
import React, { useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import ReactDOM from 'react-dom';
import {
  AiFillBank,
  AiFillCheckCircle,
  AiFillCiCircle,
  AiFillCloseCircle,
  AiFillHeart,
  AiFillStop,
  AiOutlineClose,
  AiOutlineMenu,
} from 'react-icons/ai';
import { useImmer } from 'use-immer';

type FeedDT = {
  id: string;
  label: any;
  subItems?: FeedDT[];
};
const defaultFeedList0: FeedDT[] = [{ id: 'CAT_0_1', label: '最新上架' }];
const defaultFeedList1: FeedDT[] = [
  { id: 'CAT_1_1', label: '动画里番' },
  { id: 'CAT_1_2', label: '漫画本子' },
  { id: 'CAT_1_3', label: '绅士游戏' },
  { id: 'CAT_1_4', label: '日轻小说' },
  { id: 'CAT_1_5', label: 'ASMR' },
  { id: 'CAT_1_6', label: '萌妹COS' },
];
const defaultFeedList2: FeedDT[] = [
  { id: 'CAT_2_1', label: 'COSAV' },
  { id: 'CAT_2_2', label: '网曝门' },
  { id: 'CAT_2_3', label: '探花外围' },
  { id: 'CAT_2_4', label: '反差网红' },
  { id: 'CAT_2_5', label: '黄播传媒' },
  { id: 'CAT_2_6', label: '主播热舞' },
];
const defaultFeedList3: FeedDT[] = [
  { id: 'CAT_3_1', label: '初中生' },
  { id: 'CAT_3_2', label: '萝莉岛' },
  { id: 'CAT_3_3', label: '凌辱调教' },
  { id: 'CAT_3_4', label: '同门乱伦' },
  { id: 'CAT_3_5', label: '强奸迷奸' },
  { id: 'CAT_3_6', label: '暗网重口' },
];
const defaultFeedTermList: FeedDT[] = [
  { id: 'CAT_0', label: '最新上架', subItems: defaultFeedList0 },
  { id: 'CAT_1', label: '次元分区', subItems: defaultFeedList1 },
  { id: 'CAT_2', label: '福利分区', subItems: defaultFeedList2 },
  { id: 'CAT_3', label: '暗网分区', subItems: defaultFeedList3 },
];

function QuoteApp(data: { onClose: () => void }) {
  const [feedTermList, updateTermFeedList] = useImmer<FeedDT[]>(defaultFeedTermList);
  // const [feedList0, updateFeedList0] = useImmer(defaultFeedList0);
  // const [feedList1, updateFeedList1] = useImmer(defaultFeedList1);
  // const [feedList2, updateFeedList2] = useImmer(defaultFeedList2);
  // const [feedList3, updateFeedList3] = useImmer(defaultFeedList3);

  useEffect(() => {
    Preferences.get({ key: 'customFeed' }).then((config) => {
      if (config.value) {
        updateTermFeedList(JSON.parse(config.value));
      }
    });
  }, []);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result, feedList, updateFeedList) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(feedList, result.source.index, result.destination.index);

    console.log('items', items);
    updateFeedList(items);
  };

  const onDragTermEnd = (result, feedList, updateFeedList) => {
    // dropped outside the list
    // console.log('innner drag', result);
    if (!result.destination) {
      return;
    }
    const sourceIndex = result.source.index;
    const destIndex = result.destination.index;
    if (result.type === 'droppableItem') {
      updateFeedList((draft) => {
        return reorder(draft, sourceIndex, destIndex);
      });
    } else if (result.type === 'droppableSubItem') {
      updateFeedList((draft) => {
        draft.forEach((item) => {
          if (item.id == result.source.droppableId) {
            item.subItems = reorder(item.subItems, sourceIndex, destIndex);
          }
        });
        return draft;
      });
    }
  };

  const DragdropContext = (data: { label: string; feedList: FeedDT[]; updateFeedList: any }) => {
    return (
      <>
        <div className=" w-full bg-gradient-to-br from-purple-200 to-orange-200 shadow-md rounded-md ">
          <div className=" flex justify-between items-center gap-2 px-3 py-2 bg-slate-400/70 rounded-t-md ">
            <AiOutlineMenu size={18} />
            <div className=" grow text-sm">{data.label}</div>
            <AiOutlineClose size={18} />
          </div>

          <div className=" px-3 py-1">
            <DragDropContext
              onDragEnd={(result) => {
                // onDragEnd(result, data.feedList, data.updateFeedList);
              }}
            >
              <Droppable droppableId={data.label}>
                {(provided, snapshot) => (
                  <div ref={provided.innerRef}>
                    {data.feedList.map((feedItem, feedIndex) => (
                      <Draggable
                        key={feedItem.id}
                        draggableId={feedItem.id}
                        index={feedIndex}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            className={[
                              ' my-2 text-white shadow-md rounded-md ',
                              ' bg-gradient-to-br from-purple-300 to-orange-400',
                            ].join(' ')}
                          >
                            <div className=" flex justify-between items-center gap-1 px-3">
                              <div {...provided.dragHandleProps}>
                                <AiOutlineMenu size={18} />
                              </div>
                              <div className=" grow flex justify-center items-center p-1 m-2 text-sm">
                                推荐 ● <div className=" w-20 inline-block">{feedItem.label}</div>
                              </div>
                              <AiOutlineClose
                                size={20}
                                onClick={() => {
                                  data.updateFeedList((draft) => {
                                    // Immer 提供了一个 current 函数，可以将 draft 转换为普通对象或数组
                                    console.log(current(draft));
                                    // 需要对 draft 直接修改
                                    draft.splice(feedIndex, 1);
                                    // 或者返回修改后的 draft
                                    // draft = draft.filter((item) => item.id != feedItem.id);
                                    // return draft;
                                  });
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </div>
      </>
    );
  };

  const ItemDragdropContext = (data: { id: string; index: number; feedList: FeedDT[]; updateFeedList: any }) => {
    return (
      <>
        <Droppable
          droppableId={data.id}
          type="droppableSubItem"
        >
          {(provided, snapshot) => (
            <div ref={provided.innerRef}>
              {data.feedList.map((feedItem, feedIndex) => (
                <Draggable
                  key={feedItem.id}
                  draggableId={feedItem.id}
                  index={feedIndex}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      className={[
                        ' my-2 text-white shadow-md rounded-md ',
                        ' bg-gradient-to-br from-purple-300 to-orange-400',
                      ].join(' ')}
                    >
                      <div className=" flex justify-between items-center gap-1 px-3">
                        <div {...provided.dragHandleProps}>
                          <AiOutlineMenu size={18} />
                        </div>
                        <div className=" grow flex justify-center items-center p-1 m-2 text-sm">
                          <pre className=" inline-block">{'推荐 ● '}</pre>
                          <div className=" w-24 text-left inline-block">{feedItem.label}</div>
                        </div>
                        <AiOutlineClose
                          size={20}
                          onClick={() => {
                            data.updateFeedList((draft) => {
                              // Immer 提供了一个 current 函数，可以将 draft 转换为普通对象或数组
                              console.log(current(draft));
                              // 需要对 draft 直接修改
                              draft[data.index].subItems.splice(feedIndex, 1);
                              // 或者返回修改后的 draft
                              // draft = draft.filter((item) => item.id != feedItem.id);
                              // return draft;
                            });
                          }}
                        />
                      </div>
                      {provided.placeholder}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </>
    );
  };

  const TermDragdropContext = (data: { id: string; feedList: FeedDT[]; updateFeedList: any }) => {
    return (
      <>
        <div className=" px-3 py-1 w-full">
          <DragDropContext
            onDragEnd={(result) => {
              onDragTermEnd(result, data.feedList, data.updateFeedList);
            }}
          >
            <Droppable
              droppableId={data.id}
              type="droppableItem"
            >
              {(provided, snapshot) => (
                <div ref={provided.innerRef}>
                  {data.feedList.map((feedItem, feedIndex) => (
                    <Draggable
                      key={feedItem.id}
                      draggableId={feedItem.id}
                      index={feedIndex}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          className={[
                            ' my-4 text-white shadow-md rounded-md ',
                            ' bg-gradient-to-br from-purple-200 to-orange-200',
                          ].join(' ')}
                        >
                          <div className=" w-full bg-gradient-to-br from-purple-200 to-orange-200 shadow-md rounded-md ">
                            <div className=" flex justify-between items-center gap-2 px-3 py-2 bg-slate-400/70 rounded-t-md ">
                              {/* provided.dragHandleProps 必须放在原生元素上 */}
                              <div {...provided.dragHandleProps}>
                                <AiOutlineMenu size={18} />
                              </div>
                              <div className=" grow text-sm">{feedItem.label}</div>
                              <AiOutlineClose
                                size={18}
                                onClick={() => {
                                  updateTermFeedList((draft) => {
                                    // Immer 提供了一个 current 函数，可以将 draft 转换为普通对象或数组
                                    console.log(current(draft));
                                    // 需要对 draft 直接修改
                                    draft.splice(feedIndex, 1);
                                    // 或者返回修改后的 draft
                                    // draft = draft.filter((item) => item.id != feedItem.id);
                                    // return draft;
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div className=" px-3 py-1">
                            <ItemDragdropContext
                              id={feedItem.id}
                              index={feedIndex}
                              feedList={feedItem.subItems}
                              updateFeedList={data.updateFeedList}
                            />
                          </div>
                          {provided.placeholder}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </>
    );
  };

  return (
    <div style={{ fontFamily: 'Shuhei' }}>
      <div className=" text-xs -mt-3 mb-2 text-slate-500/80">
        * 拖动
        <AiOutlineMenu className=" inline-block" />
        进行排序，点击
        <AiOutlineClose className=" inline-block" />
        排除分区
      </div>
      <div className=" flex flex-col justify-center items-center gap-4 w-full mb-16 text-nowrap">
        {/* 嵌套拖动: 参考 https: //codesandbox.io/s/5v2yvpjn7n */}
        <TermDragdropContext
          id={'droppable'}
          feedList={feedTermList}
          updateFeedList={updateTermFeedList}
        />
        {/* <DragdropContext
          label="最新上架"
          feedList={feedList0}
          updateFeedList={updateFeedList0}
        /> */}
        {/* <DragdropContext
          label="次元分区"
          feedList={feedList1}
          updateFeedList={updateFeedList1}
        /> */}
        {/* <DragdropContext
          label="福利分区"
          feedList={feedList2}
          updateFeedList={updateFeedList2}
        /> */}
        {/* <DragdropContext
          label="暗网分区"
          feedList={feedList3}
          updateFeedList={updateFeedList3}
        /> */}
      </div>

      <div
        className=" fixed left-0 bottom-0 flex justify-around items-center p-3 bg-slate-200 text-sm"
        style={{ width: window.innerWidth * 0.75 }}
      >
        <div
          className=" shadow-md rounded-md py-3 px-4 bg-[#6c6]/90 text-white flex justify-center items-center gap-1"
          onClick={async () => {
            Preferences.set({ key: 'customFeed', value: JSON.stringify(feedTermList) });
            Toast.show('已保存');
            data.onClose();
          }}
        >
          <AiFillCheckCircle />
          <div>确认保存</div>
        </div>
        <div
          className=" shadow-md rounded-md py-3 px-4 bg-[#e66]/90 text-white flex justify-center items-center gap-1"
          onClick={() => {
            updateTermFeedList(defaultFeedTermList);
            // updateFeedList0(defaultFeedList0);
            // updateFeedList1(defaultFeedList1);
            // updateFeedList2(defaultFeedList2);
            // updateFeedList3(defaultFeedList3);
            Preferences.set({ key: 'customFeed', value: JSON.stringify(defaultFeedTermList) });
            Toast.show('已重置');
            data.onClose();
          }}
        >
          <AiFillStop />
          <div>恢复默认</div>
        </div>
      </div>
    </div>
  );
}

export default QuoteApp;
